import AuthHelper from "components/auth/helpers";
import { type RootState } from "redux/store";
import { Env, WhiteLabelType } from "./Types";

import { WHITELABEL } from "utils/Constants";

export const ApiURL = {
  login: "/login",
  appStatus: "/app-status",
  refreshToken: "/refreshToken",
  // reseting passwords from within the app (i.e. just updating/changing the password)
  setPassword: "/update-password",
  // reseting passwords via email (i.e. create account and forgotten password scenarios)
  updatePasswordToken: "/update-password-token",
  // resent link
  forgotPassword: "/forgot-password",
  validToken: "/validate-token",
  whiteLabel: "/whitelabel",
  students: "/students",
  srsApplicants: "/srs-applicants",
  resetPassword: "/reset-password",
  schoolContact: "/school-contact",
  getStaffList: "/staffs",
  deleteStaff: "/delete-staff",
  transferRole: "/transfer-role",
  deleteAccount: "/delete-account",
  updateRole: "/update-role",
  rater: "/rater",
  inviteStaff: "/invite-staff",
  reportSettings: "/school-report-setting",
  config: "/config",
  year12Qual: "/qualification",
  year11Qual: "/qualification-ls11",
  submit: "/srs-applied",
  comment: "/rater-comment",
  uploadDocument: "/upload-qualification-doc",
  qualificationDocument: "/qualification/documents",
  ratingScores: "/qualification/ratings", //to get the saved score
  ratingScore: "/qualification/rating", //to submit/save rating score
  ratingStatus: "/rating-status", //to update rating status -> no longer in use
  raterComment: "/rater-comment", // to add a comment to a srs application (UTAS)
  qualification: "/qualifications-srs", //to poplate the qualification
  ratingTopics: "/rating/topics", //to get rating question items
  getEasDoc: "/download-eas-doc",
  uploadEasDoc: "/upload-eas-doc",
  flagStudent: "/add-removal-flag",
  getSrsApplicantsSummaryData: "/srs-applicants/summary",

  // eas
  eas: "/students/eas",
  easSummary: "/students/eas/summary"
};

export const AppURL = {
  login: "/",
  setPassword: "/set-password",
  forgetPassword: "/forget-password",
  maintenance: "/maintenance",
  // migration
  createAccount: "/create-account",
  school: {
    // common paths
    path: "/school", // dashboard
    students: "/school/students", // student list
    manageCredential: "/school/manage-credentials", // add a new user
    manageUser: "/school/settings", // account details
    rater: {
      srsApplications: "/school/rater/srs-applications",
      ratings: "/school/rater/ratings",
      qual: "/school/rater/quals"
    },
    easApplications: "/school/eas-applications"
  }
};

export const OUTSIDE_APP = [
  AppURL.login,
  AppURL.setPassword,
  AppURL.forgetPassword,
  AppURL.maintenance,
  AppURL.createAccount
];

export const createOrigin = (): string => {
  const origin = window.location.href.split("#");
  return origin[0];
};

export const createPath = (path: string): string => {
  return createOrigin() + "#" + path;
};

export const isAuthPage = (): boolean => {
  const current = window.location.pathname;
  return OUTSIDE_APP.includes(current);
};

export const globalLogOut = (): void => {
  if (!isAuthPage()) {
    AuthHelper.clearAuth();
    window.location.pathname = AppURL.login;
  }
};

export const buildSourceQueryParams = (
  state: RootState,
  source: Env | null
): { params: { source: Env } } | undefined => {
  const whiteLabel = state?.properties?.whiteLabel;
  return getSourceQueryParams(source, whiteLabel);
};

export const getEnabled = (env: Env | null, whiteLabel?: WhiteLabelType | null) => {
  let enabled;
  if (!whiteLabel) {
    enabled = false;
  } else if (whiteLabel === WHITELABEL.uac && env === null) {
    enabled = false;
  } else {
    enabled = true;
  }
  return enabled;
};
export const getSourceQueryParams = (env: Env | null, whiteLabel?: WhiteLabelType | null) => {
  let queryParams = undefined;
  const requiresSource = whiteLabel === WHITELABEL.uac;
  const enabled = requiresSource && env !== null;
  if (enabled) {
    queryParams = { params: { source: env } };
  }
  return queryParams;
};
